// extracted by mini-css-extract-plugin
module.exports = {"link":"Logo_link__3YBco","logoWrapper":"Logo_logoWrapper__3r-C_","image":"Logo_image__5ajmV","text":"Logo_text__1hFr0"};